import _ from 'lodash';
import { bindCallbacks, statusText } from 'scripts/infrastructure/backends/fake_backend_http/lib/common';

const STORAGE_KEY = 'gladly-fake-favorite-answers';

export default class FavoriteAnswersService {
  constructor(getDatabase, pubsub) {
    this._pubsub = pubsub;
    this.getDatabase = getDatabase;
  }

  findAll(attrs, callback, path, { orgId, agentId }) {
    callback(null, { status: 200, statusText: statusText(200), response: this._records(orgId, agentId) });
  }

  add({ answerId }, callback, path, { orgId, agentId }) {
    const all = this._readAll();
    const key = this._key(orgId, agentId);
    const records = all[key] || [];
    let record = _.find(records, { answerId });
    if (!record) {
      record = { agentId, answerId, favoritedAt: new Date().toISOString() };
      records.push(record);
      all[key] = records;
      this._writeAll(all);
    }
    callback(null, { status: 200, statusText: statusText(200), response: record });
  }

  remove(attrs, callback, path, { orgId, agentId, answerId }) {
    const all = this._readAll();
    const key = this._key(orgId, agentId);
    if (all[key]) {
      all[key] = _.reject(all[key], { answerId });
      this._writeAll(all);
    }
    callback(null, { status: 204, statusText: statusText(204) });
  }

  _records(orgId, agentId) {
    return this._readAll()[this._key(orgId, agentId)] || [];
  }

  _key(orgId, agentId) {
    return `${orgId}/${agentId}`;
  }

  _readAll() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || {};
    } catch (e) {
      return {};
    }
  }

  _writeAll(all) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(all));
    } catch (e) {
      // ignore quota errors in tests
    }
  }

  getRoutes() {
    return bindCallbacks(
      {
        '/api/v1/orgs/:orgId/agents/:agentId/favorite-answers': {
          GET: this.findAll,
          POST: this.add,
        },
        '/api/v1/orgs/:orgId/agents/:agentId/favorite-answers/:answerId': {
          DELETE: this.remove,
        },
      },
      this
    );
  }
}
